<template>
  <div>
    <v-text-field
      hide-details
      :label="title"
      prepend-inner-icon="mdi-square-edit-outline"
      @click="edit"
      v-model="text"
      filled
      readonly
    ></v-text-field>

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-simple-table>
            <thead>
              <tr>
                <th>Column Name</th>
                <th>Value Source</th>
                <th>Value</th>
                <th style="width: 40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in values" :key="item.name">
                <td>
                  <FieldPicker
                    :table="table"
                    v-model="item.name"
                    @type-change="onTypeChange"
                  />
                </td>
                <td>
                  <FieldValuePickerBase
                    :source="item.source"
                    v-model="item.value"
                    :type="fieldType"
                    :table="fieldTable"
                    :component="component"
                    :containers="containers"
                  />
                </td>
                <td>
                  <v-btn icon color="error" @click="remove(index)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="add">
            <v-icon>mdi-plus</v-icon>
            <span>Add</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="save">Ok</v-btn>
          <v-btn text color="error" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldPicker from "./FieldPicker.vue";
import FieldValuePickerBase from "./FieldValuePickerBase.vue";

export default {
  name: "ColumnValueListEditor",

  components: { FieldValuePickerBase, FieldPicker },

  props: ["title", "value", "table", "component", "containers", "fieldTable"],

  data() {
    return {
      dialog: false,
      text: null,
      values: [],
      fieldType: "text",
    };
  },

  mounted() {
    this.setText();
  },

  watch: {
    value() {
      this.setText();
    },
  },

  methods: {
    onTypeChange(t) {
      this.fieldType = t;
    },
    setText() {
      if (this.value) {
        this.text = "";
        this.value.forEach((i) => (this.text += i.name + " "));
      } else this.text = null;
    },
    edit() {
      this.values = [];

      if (this.value) {
        this.value.forEach((v) => {
          this.values.push(Object.assign({}, v));
        });
      }

      this.dialog = true;
    },
    save() {
      this.dialog = false;
      this.$emit("input", this.values);
    },
    add() {
      this.values.push({
        name: null,
        source: "value",
        value: null,
      });
    },
    remove(index) {
      this.values.splice(index, 1);
    },
  },
};
</script>
